import './spinner-facebook.css'

const SpinnerFacebook = () => {
  return (
    <div className="lds-facebook">
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}

export default SpinnerFacebook
